import qs from 'qs'
import { ItemsService } from './base-service'
import { HALApiService } from './hal-api.service'

export const storageSortingService = new ItemsService('/storage/sorting-service', HALApiService, qs)
